export default function cacheHas(cache, key) {
  return cache.has(key)
}
  
